import moment from 'moment';
import { FC } from 'react';
import { usePatientProfile } from '../../../../../../hooks/use-patient-profile';
import AccordionContent from '../../../../../shared/accordion/accordion-content';
import AccordionSection from '../../../../../shared/accordion/accordion-section';
import { PatientProfileHeader } from '../../header/header';
import { QuickNavMenu } from '../../header/quick-nav-menu/quick-nav-menu';
import { usePatientProfileWidget } from '../../hooks/use-patient-profile-widget';
import { CareCreditSection } from '../shared/sections/care-credit-section';
import { ViewContent } from '../shared/view-content/view-content';
import { FamilyMembers } from './family-members/family-members';
import { PhoneComponent } from './phone-component/phone-component';
import { PhoneType } from './types';

export const GeneralView: FC = () => {
  const { isSkinnyProfile } = usePatientProfileWidget();
  const { contactDetails, patientInfo } = usePatientProfile();

  const dateOfBirth = contactDetails.dateOfBirth ? moment(contactDetails.dateOfBirth).format('MMMM DD, YYYY') : '-';
  const email = contactDetails.email ? contactDetails.email : '-';

  const patientAddress = () => {
    const patientIndex = patientInfo.familyMembers?.findIndex((familyMember) => familyMember.id === patientInfo.id);
    return patientIndex !== -1 ? patientInfo.familyMembers![patientIndex!].address : null;
  };

  const addressLine1 = patientAddress()?.address1 ? patientAddress()?.address1 : null;
  const addressLine2 = patientAddress()?.address2 ? patientAddress()?.address2 : null;
  const addressLine3 =
    patientAddress()?.city && patientAddress()?.state && patientAddress()?.zip
      ? `${patientAddress()?.city}, ${patientAddress()?.state} ${patientAddress()?.zip}`
      : null;
  const recallDate = patientInfo.recallDate ? moment(patientInfo.recallDate).format('MM/DD/YYYY') : 'Not to Recall';

  const familyMembers = () => {
    const members = patientInfo.familyMembers;
    const filteredMembers = members?.filter((member) => member.id !== contactDetails.id);
    return filteredMembers!;
  };

  return (
    <>
      <PatientProfileHeader />
      <QuickNavMenu />
      <ViewContent sx={{ padding: '0 20px' }}>
        <AccordionSection header="Date of Birth">
          <AccordionContent>
            <label>{dateOfBirth}</label>
          </AccordionContent>
        </AccordionSection>
        <AccordionSection header="Phone Numbers">
          <AccordionContent>
            <PhoneComponent phoneNumber={contactDetails.cellPhone} phoneType={PhoneType.Mobile} />
            <PhoneComponent phoneNumber={contactDetails.homePhone} phoneType={PhoneType.Home} />
            <PhoneComponent phoneNumber={contactDetails.workPhone} phoneType={PhoneType.Work} />
          </AccordionContent>
        </AccordionSection>
        <AccordionSection header="Email">
          <AccordionContent>
            <label>{email}</label>
          </AccordionContent>
        </AccordionSection>
        {!isSkinnyProfile && (
          <>
            <AccordionSection header="Address">
              <AccordionContent>
                {addressLine1 ? (
                  <>
                    <label>{addressLine1}</label>
                    <label>{addressLine2}</label>
                    <label>{addressLine3}</label>
                  </>
                ) : (
                  '-'
                )}
              </AccordionContent>
            </AccordionSection>
            <AccordionSection header="Family">
              <AccordionContent>
                {patientInfo.familyMembers && <FamilyMembers familyMembers={familyMembers()} />}
              </AccordionContent>
            </AccordionSection>
          </>
        )}
        <AccordionSection header="Recall Date">
          <AccordionContent>
            <label>{recallDate}</label>
          </AccordionContent>
        </AccordionSection>
        <CareCreditSection />
      </ViewContent>
    </>
  );
};
